/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { stickyUrlFlag } from '@/blackbolt/stickyUrlFlag'

// Dev-selectable feed source. `?feed=<id>` picks a registered feed source for
// the session; absent, the built-in Firefly default runs. A URL flag (not a
// persisted setting) is the low-risk dev mechanism — it can't strand a user on
// a half-wired source beyond the session. Mirrors `agentProviderFlag`.

/** URL param name that selects the feed source (e.g. `?feed=<id>`). */
export const FEED_SOURCE_PARAM = 'feed'

/** The selected feed-source id for this session, or null when unset. */
export function selectedFeedSourceId(): string | null {
    // Stickied under 'feedSource' so the choice survives a route change that
    // strips the query before the feed-mount path reads it.
    return stickyUrlFlag(FEED_SOURCE_PARAM, 'feedSource')
}

/** True when a non-Firefly feed source is selected for this session. */
export function isAlternateFeedSourceSelected(): boolean {
    return selectedFeedSourceId() != null
}
